import { useCallback, useEffect, useState } from 'react';
import { pharmacyToolApi } from '../../../api/pharmacy-tool.api.js';
import { useAuth } from '../../../contexts/AuthContext.jsx';

/**
 * Quyền dùng các công cụ theo gói trả phí (GET /pharmacy-tool/access).
 * Tự hỏi lại khi đăng nhập / đăng xuất / đổi gói, nên vừa thanh toán xong quay về công cụ là mở được ngay.
 * @returns {{ access: object|null, loading: boolean, error: string|null, reload: () => void }}
 */
export function useToolAccess() {
  const { user, loading: authLoading } = useAuth();
  const [access, setAccess] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const subscriptionKey = `${user?.id || ''}:${user?.activeSubscription?.id || ''}`;

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setAccess(await pharmacyToolApi.getToolAccess());
    } catch (err) {
      setError(err.message || 'Không kiểm tra được quyền dùng công cụ');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (authLoading) return;
    reload();
  }, [authLoading, subscriptionKey, reload]);

  return { access, loading: loading || authLoading, error, reload };
}
